import Message from 'shared_components/message';
import { axiosLabAPI } from '../axios';
import { API_GET_METHOD } from 'global_config/constant-global';
import { showMessage } from 'services/settings/message';

export default async function fetchSpecimens(isActive = null) {
	let specimens = [];

	const p_is_active = [0, 1].includes(isActive) ? isActive : null;
	
	try {
		const url = `listofvalues/specimen`;

		const response = await axiosLabAPI({ 
			method: API_GET_METHOD, 
			url,
			...(p_is_active !== null ? { params: { p_is_active } } : {})
		});
		const { data } = await response;

		specimens = data.RECORDS || [];
	} catch (e) {
		showMessage(e);
	}

	return specimens;
}